document.querySelector('body').addEventListener('click', e => {
  if (e.target.classList.contains('btn--load-more')) {
    e.preventDefault();

    const url = e.target.attributes.href.value;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const grid = doc.querySelector('.blog-articles').innerHTML;
        const nextButton = doc.querySelector('.blog-view-more');
        document.querySelector('.blog-articles').innerHTML += grid;
        if(nextButton) {
          document.querySelector('.blog-view-more').innerHTML = nextButton.innerHTML;
        } else {
          document.querySelector('.blog-view-more').removeChild(document.querySelector('.blog-view-more a'));
        }
      });
  }
})
